import { render, staticRenderFns } from "./AddKhaznaTransaction.vue?vue&type=template&id=faf05438"
import script from "./AddKhaznaTransaction.vue?vue&type=script&lang=js"
export * from "./AddKhaznaTransaction.vue?vue&type=script&lang=js"
import style0 from "./AddKhaznaTransaction.vue?vue&type=style&index=0&id=faf05438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports